var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineStore } from "pinia";
import { computed, set } from "vue";
import { isInaccessible } from "@/api";
import { fetchDataset } from "@/api/datasets";
import { useKeyedCache } from "@/composables/keyedCache";
function fetchDatasetDetails(params) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetchDataset({ dataset_id: params.id, view: "detailed" });
        return response;
    });
}
export const useDatasetStore = defineStore("datasetStore", () => {
    const shouldFetch = computed(() => {
        return (dataset) => {
            if (!dataset) {
                return true;
            }
            if (isInaccessible(dataset)) {
                return false;
            }
            const isNotDetailed = !("peek" in dataset);
            return isNotDetailed;
        };
    });
    const { storedItems, getItemById, isLoadingItem, fetchItemById } = useKeyedCache(fetchDatasetDetails, shouldFetch);
    function saveDatasets(historyContentsPayload) {
        const datasetList = historyContentsPayload.filter((entry) => entry.history_content_type === "dataset");
        for (const dataset of datasetList) {
            set(storedItems.value, dataset.id, dataset);
        }
    }
    return {
        storedDatasets: storedItems,
        getDataset: getItemById,
        isLoadingDataset: isLoadingItem,
        fetchDataset: fetchItemById,
        saveDatasets,
    };
});
